import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7d83bzf5: FaireBrandEntity = {
  token: "b_7d83bzf5",
  type: "brand",
  name: "Sugar Bob's Finest Kind",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a5a736efdc5434bdb40b86fa9f665a4bef5681242d9c81e3bbeb2b041888ca77/1536736745.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/923a3c027c7bd1660ffaf0d258f1120722594205cce29e9c9c3848165e6a3e15.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a5a736efdc5434bdb40b86fa9f665a4bef5681242d9c81e3bbeb2b041888ca77/1536736745.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/923a3c027c7bd1660ffaf0d258f1120722594205cce29e9c9c3848165e6a3e15.jpeg",
  location: "Chester, VT, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 83,
  isInsider: true,
  description:
    '"Sugar Bob" has been making maple syrup in the high mountain valley of Landgrove, Vermont for much of his adult life—long enough to see saplings he walked by thirty years ago bear buckets overflowing with sap. A former home-builder and railroad man, in 2012, he took his love for sugar making to the next level by launching a business, specializing in Smoked Maple Syrup and other savory maple specialties, including four varieties of Maple Sweetened Sriracha.',
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:48.156Z",
    importedBy: "entity-db-cli",
  },
};
